import React, { useEffect, useMemo, useState } from 'react';
import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined';
import CardGame from '../../../../molecules/Card/CardGame';
import windowUtils from '../../../../../../utils/window.utils';
// import BrandConfigStore from '@/context/store/brand-config';
import useRouterHook from '@/hooks/useRouterHook.hook';
import useGameStore from '@/context/store/useGameStore.store';

const GameListProviderComponent2 = () => {
	const { router } = useRouterHook();

	const { allGameData } = useGameStore();

	// const { config: brandConfig } = BrandConfigStore();
	const [gameList, setGameList] = useState(allGameData?.body ?? []);
	// const [totalGames, setTotalGames] = useState(0);

	// const observeRef = useRef(null);
	// const latestTotalGamesRef = useRef(length);
	// const latestCurrentTotalGamesRef = useRef(length); // Keep track of the latest length value

	// Update gameList state when allGameData changes
	useEffect(() => {
		setGameList(allGameData?.body ?? []);
	}, [allGameData]);

	const filteredGameList = useMemo(() => {
		return gameList.filter((item) => item.pi === router.query.gp);
	}, [gameList, router.query.gp]);

	return (
		<React.Fragment>
			<div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-8 gap-2">
				{filteredGameList?.map((item, index) => (
					<React.Fragment key={`${item?.pi}-${item?.gi}-${index}`}>
						<CardGame game={item} />
					</React.Fragment>
				))}
			</div>

			<div
				className="fixed right-2 bottom-16 text-black z-300"
				onClick={windowUtils.onHandlerScrollToTop}>
				<div className="flex items-center justify-center w-10 aspect-square rounded-full bg-black">
					<ArrowUpwardOutlinedIcon className="w-7 h-7 text-white" />
				</div>
			</div>
		</React.Fragment>
	);
};

export default GameListProviderComponent2;
